<div
  *ngIf="isAlertVisible"
  class="mx-auto max-w-prose rounded-xl bg-warning py-6 px-4 text-center text-sm text-apricot-1"
>
  <p>Tyvärr är denna tid inte tillgänglig. Vänligen välj en annan tid.</p>
</div>
